<ng-container *ngIf="name$ | async as name">{{ name }}</ng-container>
